module.exports = __webpack_public_path__ + "img/logo.5e42e305.png";